/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab.ts";
import { courseRegistrationManagementStudentIndicatorViewModelSchema } from "../courseRegistrationManagementStudentIndicatorViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab200Schema =
  z.lazy(
    () => courseRegistrationManagementStudentIndicatorViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorTabQueryResponse>;
